export default function usePromise() {
  let resolver
  return [new Promise(resolve => { resolver = resolve }), resolver]
}